import _ from 'lodash';
import React from 'react';

const ContributorsFilterContext = React.createContext();

const toggleSelection = (list, id) => {
  const index = _.findIndex(list, { id });
  if (index >= 0) {
    return [
      ...list.slice(0, index),
      { ...list[index], selected: !list[index].selected },
      ...list.slice(index + 1),
    ];
  }
  return list;
};

const toggleAll = (list, selected) => (list.map(item => ({ ...item, selected })));

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setSelection': {
      const selection = [...(payload || [])];
      const allSelected = selection.every(c => c.selected);
      const noneSelected = selection.every(c => !c.selected);
      return {
        ...state, selection, allSelected, noneSelected,
      };
    }
    case 'toggleSelection': {
      const selection = toggleSelection(state.selection, payload);
      const allSelected = selection.every(c => c.selected);
      const noneSelected = selection.every(c => !c.selected);
      return {
        ...state, selection, allSelected, noneSelected,
      };
    }
    case 'toggleAll': {
      const selection = toggleAll(state.selection, payload);
      const allSelected = payload;
      const noneSelected = !payload;
      return {
        ...state, selection, allSelected, noneSelected,
      };
    }
    case 'setWarning': {
      return { ...state, warning: payload };
    }
    default:
      throw new Error();
  }
};

const defaultState = {
  selection: [],
  allSelected: true,
  noneSelected: false,
  warning: false,
};

export default ContributorsFilterContext;
export {
  reducer,
  defaultState,
};
